export default {
  canBrowseCatalogSuppliers(state, getters, rootState) {
    return !(
      rootState.auth.user.showOnlyMyCatalogData || rootState.auth.user.org.filterCatalogBySuppliers.length === 1
    );
  },
};
